import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { Tabs, Tab, Button } from "react-bootstrap";
import { api_url } from "../../constant/constant";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { showToast } from "../../Components/ShowToast/ToastNotification";
import EditComplianceSurvey from "../../Components/EditComplianceSurveyModal/EditComplianceSurvey";
import ComplianceSurveyQuestion from "../../Components/ComplianceSurveyQuestionModal/ComplianceSurveyQuestion";

// import './SurveyDetail.css';

const ComplianceSurveyDetail = () => {
  const { t } = useTranslation();
  const { survey_id } = useParams();
  const [key, setKey] = useState("details");

  // State variables
  const [data, setVideos] = useState([]);
  const [links, setLinks] = useState([]);

  const navigate = useNavigate();

  return (
    <div className="p-4 mb-4">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <div className="pageTitle">{t("ComplianceSurveyDetails")}</div>
        <Button variant="primary" onClick={() => navigate(-1)}>
          {t("Back")}
        </Button>
      </div>

      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="details" title={t("EditComplianceSurvey")}>
          <div>
            <EditComplianceSurvey id={survey_id} />
          </div>
        </Tab>

        <Tab eventKey="questions" title={t("ComplianceSurveyQuestions")}>
          <div>
            <ComplianceSurveyQuestion />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default ComplianceSurveyDetail;
